import { t } from 'i18next';
import { convertToDate } from 'common';
import { ContactInfo, Paragraph } from '@sentara-health/optimahealth_web';
export interface IphoneNumber {
  readonly benefitPhone: string;
  readonly benefitPhoneLocal: string;
}

function HeaderContent({
  benefitPhone,
  benefitPhoneLocal,
}: Readonly<IphoneNumber>) {
  let startDate;
  let endDate;
  const date = new Date();

  const selectedOption = t('common.selectedOption');
  const currentYear = date.getFullYear();
  const yearData = localStorage.getItem(selectedOption) ?? String(currentYear);
  if (Number(yearData) === date.getFullYear()) {
    startDate = convertToDate(new Date(date.getFullYear(), 0, 1));
    endDate = convertToDate(date);
  } else {
    startDate = convertToDate(new Date(date.getFullYear() - 1, 0, 1));
    endDate = convertToDate(new Date(date.getFullYear(), 0, 0));
  }

  return (
    <>
      <Paragraph
        text={
          <>
            {' '}
            {t('viewTaxSummary.billInstruction1')}{' '}
            {t('viewTaxSummary.billInstruction2')} {startDate}{' '}
            {t('viewTaxSummary.billInstruction4')} {endDate}.
          </>
        }
        variant="regular"
        data-testid="taxYearSummary"
        className="header_content"
      />
      <Paragraph
        text={
          <>
            {t('viewTaxSummary.billInstruction3')}{' '}
            <ContactInfo
              phoneData={{
                phone1800: benefitPhone,
                phoneLocal: benefitPhoneLocal,
              }}
              dataTestId="contactInfo"
              className="ps-1"
            />
          </>
        }
        variant="regular"
        data-testid="billInstruction"
        className="mb-4"
      />
    </>
  );
}
export default HeaderContent;
